import React from 'react';
export const HeroSection = () => {
  return <div className="py-20 bg-gradient-to-r from-[#FDFCFB] to-[#E8EDF3]" data-id="element-125">
      <div className="container mx-auto px-6 max-w-4xl text-left" data-id="element-126">
        <div className="mb-4" data-id="element-127">
          <span className="bg-[#E63946] text-white text-xs font-semibold px-4 py-1 rounded-full uppercase tracking-wide shadow-sm" data-id="element-128">
            Exclusive Report
          </span>
        </div>
        <h1 className="text-4xl lg:text-6xl font-bold text-[#0A1F44] mb-6 leading-tight" data-id="element-129">
          Harvard Scientist Reveals: Why 77% of Adults Are Constantly Mentally
          Exhausted (and the Natural Remedy Hidden from You)
        </h1>
        <p className="text-xl text-gray-700 mb-8 italic font-light" data-id="element-130">
          Discover the root cause of your persistent fatigue and brain fog—and
          the ancient secret that's transforming thousands of lives.
        </p>
        <div className="text-sm text-gray-600 mb-10" data-id="element-131">
          <span data-id="element-132">
            By{' '}
            <span className="font-semibold text-gray-800" data-id="element-133">Dr. Sarah Chen</span>
          </span>
          <span className="mx-2" data-id="element-134">|</span>
          <span data-id="element-135">Updated July 9, 2025</span>
        </div>
        <div className="w-full" data-id="element-136">
          <img src="https://cdn.shopify.com/s/files/1/0637/1675/3506/files/assets_task_01jzrby1ezerg945ksgt92ck87_1752090862_img_0.webp?v=1752090885" alt="Dr. Sarah Chen conducting research in her Harvard lab" className="w-full rounded-xl shadow-xl object-cover" data-id="element-137" />
        </div>
      </div>
    </div>;
};